import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
    setApplicationDetails,
    setApplicationRequirementDetails,
    setGeneralDetails,
    setLoginDetails
} from "../../../actions/actions";
import {connect} from "react-redux";

function PgSidebar(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [active, setActive] = useState("");
    const handleLogout = () => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
        props.setOnGeneralDetails("")
        props.setOnApplicationRequirementDetails([])
        navigate("/login");
    };;
    useEffect(() => {
        if (location.pathname === '/postgraduate/dashboard')
            setActive('dashboard')
        else if (location.pathname === '/postgraduate/personal-information')
            setActive('info')
        else if (location.pathname === '/postgraduate/academic-qualifications')
            setActive('academic')
        else if (location.pathname === '/postgraduate/employment-details')
            setActive('employment')
        else if (location.pathname === '/postgraduate/document-uploads')
            setActive('document')
        else if (location.pathname === '/postgraduate/application-preview')
            setActive('preview')
        else
            setActive('dashboard')
    }, [location])
    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li>
                            <h6 className="submenu-hdr"><span>Main</span></h6>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'dashboard' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'dashboard' ? 'text-white' : ''}>Dashboard</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'info' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'info' ? 'text-white' : ''}>Personal Information</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'academic' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'academic' ? 'text-white' : ''}>Academic Qualifications</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'employment' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'employment' ? 'text-white' : ''}>Employment Details</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'document' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'document' ? 'text-white' : ''}>Document Upload</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'preview' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'preview' ? 'text-white' : ''}>Preview</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li><div className="widget row pb-4 mb-5 mt-4">
                                    <div className="col-lg-12 col-sm-12">
                                        <button className="btn btn-sm btn-info w-100" onClick={handleLogout}>
                                            Logout
                                        </button>
                                    </div>
                                </div></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setOnApplicationRequirementDetails: (p) => {
            dispatch(setApplicationRequirementDetails(p));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PgSidebar);
